module.exports = __webpack_public_path__ + "media/images/hero-pattern-1-107b861a167d0b15b0c870a7caf6c3ea.jpeg";